






import Component from 'vue-class-component'
import Vue from 'vue'

@Component({
  props: {
    facility: {
      type: Object
    }
  }
})
export default class FacilityLabel extends Vue {
  get shortName () {
    if (this.$props.facility.shortName) {
      return this.$props.facility.shortName.trim()
    }
    return ''
  }

  get fullName () {
    return this.$props.facility.name ? this.$props.facility.name : ''
  }
}
